import { withInstallFunction } from '@bigin/utils'

import Notify from './src/notify'

export const BNotification = withInstallFunction(Notify, '$notify')
export default BNotification

export * from './src/notification'
